import { createFileRoute } from '@tanstack/react-router'

import SubmissionPage from '@/components/pages/backoffice/edit-penyuluh/submission/containers/SubmissionPage'

export const Route = createFileRoute('/_backoffice/edit-penyuluh/submission/')({
  component: SubmissionPage
})
